import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import menu from './menu/reducers'
import questions from './questions/reducers'
import groups from './groups/reducers'
import schools from './schools/reducers'
import bookings from './bookings/reducers'
import configs from './configs/reducers'
import settings from './settings/reducers'
import costCenters from './cost-centers/reducers'

export default history =>
  combineReducers({
    router: connectRouter(history),
    user,
    menu,
    settings,
    questions,
    groups,
    schools,
    bookings,
    configs,
    costCenters,
  })
